<template>
  <nav
    class="app-navbar"
    :style="navbarStyle"
  >
    <div class="app-navbar__content row">
      <div class="app-navbar__menu-container">
        <router-link
          class="app-navbar__logo mr-3"
          to="/"
        >
          <img src="../../../assets/logo-long.png" alt="Rewarding Dog Training logo" />
        </router-link>
      </div>
      <app-navbar-pages-unauth />
      <unauth-dropdown />
    </div>
  </nav>
</template>

<script>
import AppNavbarPagesUnauth from './components/AppNavbarPagesUnauth'
import UnauthDropdown from './components/dropdowns/UnauthDropdown'
import { ColorThemeMixin } from '../../../services/vuestic-ui'

export default {
  name: 'app-navbar-unauth',
  mixins: [ColorThemeMixin],
  inject: ['contextConfig'],
  components: {
    AppNavbarPagesUnauth,
    UnauthDropdown,
  },
  props: {
    isTopBar: {
      type: Boolean,
      required: true,
    },
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isTopBarProxy: {
      get () {
        return this.isTopBar
      },
      set (isTopBar) {
        this.$emit('update:isTopBar', isTopBar)
      },
    },
    minimizedProxy: {
      get () {
        return this.minimized
      },
      set (minimized) {
        this.$emit('update:minimized', minimized)
      },
    },
    navbarStyle () {
      const style = {
        backgroundColor: 'white',
        'border-bottom': `1px solid ${this.$themes.lighterGray}`,
      }
      return style
    },
  },
}
</script>

<style lang="scss">
$nav-border-side-width: 3.1875rem;

.app-navbar {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  transition: background-color 0.3s ease; /* sidebar's bg color transitions as well -> consistency */
  display: flex;
  padding: 1rem 1rem;
  z-index: 100;
  text-transform: uppercase;

  &__content {
    z-index: 100;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    height: 100%;
    flex: 1 1 auto;
  }

  &__menu {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    margin-right: 1.5rem;
  }

  &__menu-container {
    display: flex;
    flex-wrap: nowrap;
    height: 1.5rem;
  }

  &__logo {
    width: auto;
    height: 3rem;
    align-items: center;

    & * {
      position: relative;
      top: -10px;
      max-height: 100%;
      max-width: 100%;
      height: 100%;
      display: block;
    }
  }

  .nav-toggle {
    & > div {
      width: 100%;
      height: 0.2rem;
      margin: 0;
      border-radius: 1rem;
      background-color: $gray;

      &:not(:first-child) {
        margin-top: 0.6rem;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    &__content {
      align-items: flex-end;
    }

    &__shape {
      display: none;
    }
  }
}
</style>
